/*
 * File: cell-hierachy-item.ts
 * File Created: 2024-03-01 03:16:51
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2026-01-16 12:11:40
 * Modified By: Val Liu <valuis0429@gmail.com>
 * -----
 */

import {
    BaseTableBodyCell,
    defaultTableBodyCellData,
    ITableBodyCellData,
} from "@root/components/table/core/lib/base-table-body-cell/base-table-body-cell";
import { UITag } from "@root/core/tags";
import { ObjectHelper } from "@root/core/utilities/object-helper";
import {
    IQuickHierachySummary,
    IQuickUnit,
    IQuickUnitGeneralizedSubTree,
    QuickHelper,
} from "@root/core/utilities/quick-helper";
import { StringHelper } from "@root/core/utilities/string-helper";
import { Component, Inject, Prop } from "vue-property-decorator";
import { defaultData, ICellHierachyData } from "../cell-hierachy/cell-hierachy";

@Component
@UITag.setDefault({
    uiAlign: "center",
    uiSort: false,
    uiSearch: false,
})
export default class CellHierachyItem extends BaseTableBodyCell {
    @Prop({ type: Object, required: true })
    quick!: IQuickUnit;

    @Prop({ type: Object, required: false })
    declare data: (ICellHierachyData & ITableBodyCellData) | undefined;
    get mergedData() {
        return {
            ...defaultTableBodyCellData,
            ...defaultData,
            ...this.data,
        };
    }

    @Inject({ default: null })
    readonly prefix!: string | null;
}
